import { useMemo } from 'react';

export type OSType = 'android' | 'ios' | 'macos' | 'windows' | 'linux' | 'unknown';

// Extend Window interface to include MSStream (older IE)
interface WindowWithMSStream extends Window {
  MSStream?: unknown;
}

export function useDeviceOS(): OSType {
  return useMemo(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return 'unknown';
    }

    const userAgent = navigator.userAgent || navigator.vendor || '';
    const windowRef = window as WindowWithMSStream;

    // iOS detection (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !windowRef.MSStream) {
      return 'ios';
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      return 'android';
    }

    // MacOS detection
    if (/Macintosh|Mac OS X|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      // iPad on iOS 13+ reports as Mac, check for touch
      if (navigator.maxTouchPoints > 1) {
        return 'ios';
      }
      return 'macos';
    }

    // Windows detection
    if (/Win32|Win64|Windows|WinCE/.test(userAgent)) {
      return 'windows';
    }

    // Linux detection
    if (/Linux|X11/.test(userAgent)) {
      return 'linux';
    }

    return 'unknown';
  }, []);
}

export function isMobile(os: OSType): boolean {
  return os === 'android' || os === 'ios';
}
